<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    tableClass="table-responsive-sm"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    @error-load="showError"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle"
                                    />
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:beforeTable="{ tableFilters }" v-if="!isSingleLocale">
                        <div class="row" v-if="filterLocale.length">
                            <div class="col-md-6">
                                <div class="row no-gutters form-group btn-group-toggle-city main">
                                  <div :class="'col-'+ (12/filterLocale.length)" :for="'action-'+item.id" v-for="(item, index) in filterLocale" :key="index">
                                    <label class="btn btn-sm btn-block z-depth-0" :class="{'active': item.code == tableFilters.locale}">
                                        <input type="radio" name="toogle-action" :id="'action-'+item.id" :value="item.code" v-model="tableFilters.locale" autocomplete="off"> <span class="">{{ item.name }}</span>
                                    </label>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <td :class="table.columns[0].class">
                            {{ columnValue(row, table.columns[0]) }}
                        </td>
                        <td :class="table.columns[1].class">
                            <template v-if="table.columns[1].route">
                                <router-link
                                    target='_blank'
                                    :to="table.columns[1].route(row, table.columns[1])">
                                    {{ columnValue(row, table.columns[1]) }}
                                </router-link>
                            </template>
                            <template v-else>
                                {{ columnValue(row, table.columns[1]) }}
                            </template>
                        </td>
                        <td :class="table.columns[2].class">{{ columnValue(row, table.columns[2]) }}</td>
                        <td :class="table.columns[3].class">{{ columnValue(row, table.columns[3]) | toDate}}</td>
                        <td :class="table.columns[4].class" v-html="columnStatus(row, table.columns[4], ['fa fa-eye','fa fa-eye-slash'])"></td>
                        <column-actions
                            v-if="checkActions"
                            label="title"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove"
                        />
                    </template>
                </table-data>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import GeneralMixin from '../../mixin'

    export default {
        mixins: [GeneralMixin],
        data() {
            let pageID = 'news';
            return {
                pageID: pageID,
                table: {
                    columns: [
                        {
                            label: `${pageID}.list.order`,
                            field: 'order',
                            sortable: true,
                            class: 'w-100px',
                        },
                        {
                            label: `${pageID}.list.title`,
                            field: 'title',
                            fieldRoute: 'slug',
                            route: (row, data) => {
                                let _key = data.fieldRoute;
                                let _val =  this.columnValue(row, data, _key);
                                let _route =  {
                                    name: `portal.news.single`,
                                    params: {
                                        preview: 'preview'
                                    }
                                };
                                _route.params[_key] = _val;
                                return _val ? _route : null;
                            },
                            sortable: true,
                        },
                        // {
                        //     label: this.$t(`${pageID}.list.subtitle`),
                        //     field: 'subtitle',
                        //     sortable: false,
                        // },
                        {
                            label: `${pageID}.list.category`,
                            field: 'category.name',
                            sortable: true,
                        },
                        {
                            label: `${pageID}.list.published_at`,
                            field: 'published_at',
                            sortable: true,
                            class: 'text-center',
                        },
                        {
                            label: `${pageID}.list.published`,
                            field:  'published',
                            sortable: true,
                            class: 'w-100px text-center',
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                    filters: {
                        q: '',
                        locale: '',
                    },
                    settings: {
                        sort: 'desc',
                        order_by: 'published_at',
                    },
                },
            }
        },
        filters: {
            toDate: function(value) {
                return moment(value, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
            }
        },
        beforeMount() {
            if(this.isSingleLocale) {
                this.table.filters.locale = this.defaultLocale ? this.defaultLocale.code : null;
            }
        },
    }
</script>
